<template lang="pug">
	.auth(:class="state")
		.logo
			.img-publisher(v-if="User.invitationDetails" :style="{background: `url(/Images/Icons/Publishers/${User.invitationDetails.publisherCodename || User.invitationDetails.publisherId}.png) center / contain no-repeat`}")
			.img
		.auth-forms(v-if="Metadata.loaded && Publisher.loaded")
			.login-area
				.login-content
					.title Login
					.description(v-if="!User.invitationDetails") Sign in to your company account if you already have access to {{Metadata.Config['dashboard-page-title'] || ''}}
					.description(v-if="User.invitationDetails") Hi, {{User.invitationDetails.userName}}! Please sign in to accept invitation to the {{User.invitationDetails.publisherTitle}} account.
					.buttons
						img.google-login(v-on:click="openGoogleLogin()" src="../../../public/Images/Screens/Login/sign-in-with-google.png")
						img.linked-in-login(v-on:click="openLinkedInLogin()" src="../../../public/Images/Screens/Login/sign-in-with-linkedin.png")
			.signup-area
				.signup-content
					.back-right(v-on:click="state = ''")
						.fa.fa-angle-double-right
					.back-left(v-on:click="state = ''")
						.fa.fa-angle-double-left
					.title Sign Up
					.description Create a new company account and try demo playables for free
					.controls
						.sign-up-controls.start-sign-up
							button.btn.btn-lg.btn-outline-light(v-on:click="state = 'sign-up'") Create a company account
						.sign-up-controls.end-sign-up
							.input-group.mb-3
								.input-group-prepend
									span.input-group-text
										.icon.fa.fa-building
								input.form-control(type="text" placeholder="Company name" v-model="companyName")
							.buttons(:style="{pointerEvents: _.kebabCase(companyName).length >= 2 ? 'auto' : 'none', opacity: _.kebabCase(companyName).length >= 2 ? '1' : '0.2'}")
								img.google-login(v-on:click="openGoogleSignUp()" src="../../../public/Images/Screens/Login/sign-up-with-google.png")
								img.linked-in-login(v-on:click="openLinkedInSignUp()" src="../../../public/Images/Screens/Login/sign-up-with-linkedin.png")
</template>

<script>
	import Screen 							from './../../mixins/screen'
	import SetupSettings 					from "./../../settings/settings.json"

	import { Metadata } 					from './../../services/Metadata'
	import { Publisher } 					from './../../services/Publisher'
	import { User } 						from './../../services/User'

	export default {
		name: 'Auth',
		mixins: [Screen],
		screen: {
			updateOn: ["Current User Changed", "Metadata Loaded", "Publishers Exists Changed", "Invitation Details Changed"]
		},
		data() {

			this.Publisher = Publisher;
			this.User = User;

			return {
				showed: true,
				state: '',
				companyName: ''
			}

		},
		methods: {
			collectData() {

				if (Metadata.Config['feature-single-publisher'] && Publisher.isPublisherExists) this.state = 'auth-only';
				if (Layout.invitationRequested) this.state = 'invitation';

			},
			openLinkedInLogin() {

				document.location = SetupSettings.loginUrlLinkedIn + (User.invitationDetails ? `?acceptInvitation=${Layout.invitationRequested}` : '');

			},
			openGoogleLogin() {

				document.location = SetupSettings.loginUrlGoogle + (User.invitationDetails ? `?acceptInvitation=${Layout.invitationRequested}` : '');

			},
			openLinkedInSignUp() {

				document.location = SetupSettings.loginUrlLinkedIn + '?createCompanyAccount=' + encodeURIComponent(this.companyName);

			},
			openGoogleSignUp() {

				document.location = SetupSettings.loginUrlGoogle + '?createCompanyAccount=' + encodeURIComponent(this.companyName);

			}
		}
	}
</script>

<style lang="sass" scoped>
	
	.auth
		display: flex
		flex-direction: column
		justify-content: center
		align-items: center
		background: center top / 100% auto no-repeat fixed
		background-size: cover
		min-height: 100vh

		.logo
			display: flex
			flex-direction: column
			align-items: center
			justify-content: center
			height: 13vh
			width: 100%
			padding: 20px
			padding-bottom: 0

			.img
				height: 60%
				width: 90%
				background: url("../../../public/Images/Screens/Login/dashboard-logo.png") center / contain no-repeat
				image-rendering: -webkit-optimize-contrast

			.img-publisher
				margin-bottom: 15px
				height: 40%
				width: 90%
				image-rendering: -webkit-optimize-contrast

		.auth-forms
			display: flex
			flex-direction: row
			align-items: center
			justify-content: center
			width: 90vw
			max-width: 850px
			background-color: #24252f
			box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .14), 0 2px 1px -1px rgba(0, 0, 0, .12), 0 1px 3px 0 rgba(0, 0, 0, .20)
			border-radius: 0.25rem
			margin: 20px
			overflow: hidden
			font-size: 0
			height: 260px
			transition: width 0.5s ease-in-out, max-width 0.5s ease-in-out

			.login-area
				width: 50%
				height: 100%
				color: rgba(255, 255, 255, 0.87)
				text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.27)
				font-weight: normal
				transition: width 0.5s ease-in-out, height 0.5s ease-in-out

				.login-content
					margin: 2.75rem
					width: 45vw
					max-width: calc(850px / 2 - 2.75rem * 2)

					.title
						font-size: 2.1875rem

					.description
						color: rgba(255, 255, 255, 0.6)
						font-size: 0.875rem

					.buttons
						display: flex
						flex-direction: row
						align-items: center
						justify-content: left
						margin-top: 1rem

						.linked-in-login
							display: flex
							height: 34px
							background-size: contain
							cursor: pointer
							filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4))
							margin-left: 10px
							image-rendering: -webkit-optimize-contrast

						.google-login
							display: flex
							height: 34px
							cursor: pointer
							filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4))
							image-rendering: -webkit-optimize-contrast

			.signup-area
				width: 50%
				height: 100%
				background-color: var(--green)
				padding: 2.75rem
				color: rgba(255, 255, 255, 0.87)
				text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.27)
				font-weight: normal
				position: relative
				transition: width 0.5s ease-in-out

				.signup-content
					width: 45vw
					max-width: calc(850px / 2 - 2.75rem * 2)

					.back-right
						display: none
						font-size: 0.875rem
						width: 30px
						height: 30px
						position: absolute
						right: 10px
						top: 10px
						align-items: center
						justify-content: center
						opacity: 0
						transition: opacity 0.2s ease-in-out

					.back-left
						font-size: 0.875rem
						width: 30px
						height: 30px
						position: absolute
						left: 10px
						top: 10px
						display: flex
						align-items: center
						justify-content: center
						opacity: 0
						transition: opacity 0.2s ease-in-out

					.title
						font-size: 2.1875rem

					.description
						color: rgba(255, 255, 255, 1)
						font-size: 0.875rem

					.controls
						position: relative
						width: 99%
						height: 220px
						margin-top: 1rem

						.sign-up-controls
							position: absolute
							left: 0
							top: 0
							width: 100%
							transition: opacity 0.5s ease-in-out

						.start-sign-up

							button

						.end-sign-up
							opacity: 0
							pointer-events: none

							.buttons
								display: flex
								flex-direction: row
								align-items: center
								justify-content: left
								margin-top: 1rem
								transition: opacity 0.2s ease-in-out

								.linked-in-login
									display: flex
									height: 35px
									background-size: contain
									cursor: pointer
									filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4))
									margin-left: 10px

								.google-login
									display: flex
									height: 35px
									cursor: pointer
									filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4))

	.auth.sign-up

		.auth-forms
			max-width: 550px

			.login-area
				width: 0
				padding: 0

				.login-content


			.signup-area
				width: 100%

				.back-left
					opacity: 1
					cursor: pointer

				.controls

					.start-sign-up
						opacity: 0
						pointer-events: none

					.end-sign-up
						opacity: 1
						pointer-events: auto

	.auth.auth-only

		.auth-forms
			max-width: 450px
			transition: none

			.login-area
				width: 100%
				transition: none

			.signup-area
				display: none

	.auth.invitation

		.auth-forms
			max-width: 450px
			transition: none

			.login-area
				width: 100%
				transition: none

			.signup-area
				display: none

	@media screen and (max-width: 800px)

		.auth

			.auth-forms
				flex-direction: column
				height: auto
				align-items: start

				.login-area
					width: 100%
					height: 300px

					.login-content
						width: calc(90vw - 2.75rem * 2)
						max-width: calc(90vw - 2.75rem * 2)

						.buttons
							flex-direction: column
							align-items: start

							.linked-in-login
								margin-left: 0
								margin-top: 10px

				.signup-area
					width: 100%
					height: auto

					.signup-content
						width: 100%

		.auth.sign-up

			.auth-forms

				.login-area
					padding: 0
					height: 0

					.login-content

				.signup-area
					width: 100%

					.back-left
						opacity: 1
						cursor: pointer

					.sign-up-controls.end-sign-up

						input.form-control
							border-color: hsla(0,0%,100%,.5) !important

</style>
